module.exports = __webpack_public_path__ + "img/tuangou.c31b0d7f.png";